import axios from 'axios';

const getAdsApi = async (langIsoCode) => {
  try {
    const url = '/General/ads';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getAdsApi;
